import Slider, { CustomArrowProps } from "react-slick";
import FavouriteBrandContainer from "./favouriteBrandContainer";
import TopBrandCard from "../commonComponents/brandCards/topBrandCard";
import { Box, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { favouriteBrandsSelector } from "../../store/metadata/selector";
import { brandItem } from "../../store/metadata/types";
import { DiscoverySagaActions } from "../../store/discovery/sagas";
import { useTheme } from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { TopBrandsListWrapper } from "../../pageComponents/style";

const NavigateButtonStyle = {
  fill: "#58595B",
  background: "white",
  border: "1px solid #EAECEE",
  borderRadius: "50%",
  padding: "0.25rem",
  margin: "0.25rem",
};
const DisableBtnStyle = {
  opacity: "50%"
}
const NextArrow = ({ className, onClick }: CustomArrowProps) => {
  const btnStyle = onClick? NavigateButtonStyle : {...NavigateButtonStyle,...DisableBtnStyle}
  return (
    <NavigateNextIcon
      onClick={onClick}
      className={className}
      sx={btnStyle}
    />
  );
};

const PrevArrow = ({ className, onClick }: CustomArrowProps) => {
  const btnStyle = onClick? NavigateButtonStyle : {...NavigateButtonStyle,...DisableBtnStyle}
  return (
    <NavigateBeforeIcon
      onClick={onClick}
      className={className}
      sx={btnStyle}
    />
  );
};

const FavouriteBrandDiscovery = () => {
  const favouriteBrands = useSelector(favouriteBrandsSelector);
  const dispatch = useDispatch();
  const theme = useTheme();
  const handleViewAd = (brandId?: string) => {
    dispatch(DiscoverySagaActions.fetchBrandDiscoveryItems({ brandId }));
  };

  const brandCount = favouriteBrands.length;

  const getSlidesToShow = (count: number, max: number) => Math.min(count, max);

  const settings = {
    slidesToShow: getSlidesToShow(brandCount, 6),
    infinite: false,
    slidesToScroll: 1,
    nextArrow: favouriteBrands.length > 5 ? <NextArrow /> : <></>,
    prevArrow: favouriteBrands.length > 5 ? <PrevArrow /> : <></>,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: Math.min(favouriteBrands?.length, 5),
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: Math.min(favouriteBrands?.length, 4),
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(favouriteBrands?.length, 2),
        },
      },
    ],
  };

  return (
    <FavouriteBrandContainer defaultExpanded={brandCount > 0}>
      {brandCount === 0 ? (
        <Box
          margin="auto"
          color={theme.colors.black2}
          fontWeight={500}
          fontSize="0.938rem"
        >
          No Favourite Brands
        </Box>
      ) : brandCount <= 4 ? (
        <Grid container spacing={2} justifyContent="flex-start">
          {favouriteBrands.map((brand: brandItem, index: number) => (
            <Grid item key={brand._id}>
              <TopBrandCard
                buttonsToShow={["viewAdsButton"]}
                isDiscovery
                index={`0${index + 1}`}
                item={brand}
                handleViewAd={handleViewAd}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <TopBrandsListWrapper style={{ width: "100%" }}>
          <Slider {...settings}>
            {favouriteBrands.map((brand: brandItem, index: number) => (
              <TopBrandCard
                key={brand._id}
                buttonsToShow={["viewAdsButton"]}
                isDiscovery
                index={`0${index + 1}`}
                item={brand}
                handleViewAd={handleViewAd}
              />
            ))}
          </Slider>
        </TopBrandsListWrapper>
      )}
    </FavouriteBrandContainer>
  );
};

export default FavouriteBrandDiscovery;
